import { UserDto } from '@interfaces/userInterface';
import { userService } from '@services/index';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export default function useMutationAddUser() {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: (userDto: UserDto) => userService.createUser(userDto),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['Users'] });
		}
	});
}
